import { useState, useEffect } from 'react';
import {
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomInput,
  CustomNumberInput,
  warningDialog,
  Text,
} from '@src/components';
import iconSearchWhite from '@src/assets/icons/icon-white-search.svg';
import { Button, Col, Form, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCardBalanceList,
  setEntryList,
  setExitList,
  setSelectedEntryRow,
  setSelectedEntryRowKeys,
  setSelectedExitRow,
  setSelectedExitRowKeys,
} from '@src/store/slice/balanceTransferSlice';
import PropTypes from 'prop-types';

const BalanceTypeFilter = ({ type, statusId, isClear, setIsClear }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const globalState = useSelector((state) => state?.balanceTransfer);
  const [searchDisabled, setSearchDisabled] = useState(true);

  const onChangeForm = (values) => {
    const result = values.some((val) => {
      return val.value && String(val.value).trim().length > 0;
    });

    setSearchDisabled(!result);
  };

  const onSearch = async (values) => {
    const searchValues = {};

    Object.keys(values).forEach((item) => {
      if (values[item] && String(values[item]).trim().length > 0) {
        searchValues[item] = String(values[item]);
      }
    });

    searchValues.statusId = statusId;
    const action = await dispatch(
      getCardBalanceList({
        body: searchValues,
        pageNumber: globalState[type].pageNumber,
        pageSize: globalState[type].pageSize,
        type,
      }),
    );

    if (action?.payload?.response?.data.length == 1) {
      if (
        action?.payload?.response?.data[0].customerId == 0 &&
        action?.payload?.response?.data[0].errorMessage
      ) {
        warningDialog({
          title: <Text t="attention" />,
          message: action?.payload?.response?.data[0].errorMessage,
        });
        dispatch(setExitList([]));
        dispatch(setEntryList([]));
        return;
      }
    }
    if (getCardBalanceList.rejected.match(action)) {
      if (action?.meta?.arg?.type === 'exit') {
        dispatch(setExitList([]));
      }
      if (action?.meta?.arg?.type === 'entry') {
        dispatch(setEntryList([]));
      }
    }

    if (
      globalState.selectedExitRow &&
      globalState.selectedExitRowKeys.length > 0 &&
      type === 'exit'
    ) {
      await dispatch(setSelectedExitRow(null));
      await dispatch(setSelectedExitRowKeys([]));
    }

    if (
      globalState.selectedEntryRow &&
      globalState.selectedEntryRowKeys.length > 0 &&
      type === 'entry'
    ) {
      await dispatch(setSelectedEntryRow(null));
      await dispatch(setSelectedEntryRowKeys([]));
    }
  };
  useEffect(() => {
    form.resetFields();
    setIsClear(false);
    dispatch(setSelectedEntryRow(null));
    dispatch(setSelectedExitRow(null));
    dispatch(setSelectedEntryRowKeys([]));
    dispatch(setSelectedExitRowKeys([]));
  }, [isClear]);

  return (
    <div className="balance-type-filter-card">
      <CustomForm
        name="filterForm"
        className="filter-form"
        autoComplete="off"
        layout={'horizontal'}
        form={form}
        onFinish={onSearch}
        onFieldsChange={(_, allFields) => {
          onChangeForm(allFields);
        }}
      >
        <Row gutter={12}>
          <Col span={24}>
            <CustomFormItem
              label={<span className="form-label"><Text t="cardNumber3" /></span>}
              name="cardNumber"
              className="name-form-item"
            >
              <CustomNumberInput
                id="ticketRestaurant-manageMyCards-balanceTransfer-balnceTypeFilter-cardNumber-numberInput"
                data-testid="cardNumber"
                autoComplete="off"
                height={36}
              />
            </CustomFormItem>
          </Col>

          <Col span={24}>
            <CustomFormItem
              label={
                <span className="form-label">
                  <Text t="referenceCode" />
                </span>
              }
              name="refNo"
              className="name-form-item"
            >
              <CustomInput
                id="ticketRestaurant-manageMyCards-balanceTransfer-balnceTypeFilter-refNo-input"
                data-testid="refNo"
                autoComplete="off"
                height={36}
              />
            </CustomFormItem>
          </Col>

          <Col span={12}>
            <CustomFormItem
              label={
                <span className="form-label">
                  <Text t="name2" />
                </span>
              }
              name="name"
              className="name-form-item"
            >
              <CustomInput
                id="ticketRestaurant-manageMyCards-balanceTransfer-balnceTypeFilter-name-input"
                data-testid="name"
                autoComplete="off"
                height={36}
              />
            </CustomFormItem>
          </Col>

          <Col span={12}>
            <CustomFormItem
              label={<span className="form-label"><Text t="surname3" /></span>}
              name="surname"
              className="name-form-item"
            >
              <CustomInput
                id="ticketRestaurant-manageMyCards-balanceTransfer-balnceTypeFilter-surname-input"
                data-testid="surname"
                autoComplete="off"
                height={36}
              />
            </CustomFormItem>
          </Col>
        </Row>

        <div className="form-footer">
          <div className="action-buttons">
            <Button
              id="ticketRestaurant-manageMyCards-balanceTransfer-balanceTypeFilter-search-btn"
              data-testid="search"
              disabled={searchDisabled}
              htmlType="submit"
              className="search-btn"
            >
              <CustomImage className="icon-search" src={iconSearchWhite} /> <Text t="search" />
            </Button>
          </div>
        </div>
      </CustomForm>
    </div>
  );
};

export default BalanceTypeFilter;

BalanceTypeFilter.propTypes = {
  type: PropTypes.string,
  statusId: PropTypes.any,
  isClear: PropTypes.bool,
  setIsClear: PropTypes.any,
};
